import styled from '@emotion/styled';
import useScrollPosition from 'hooks/useScrollPosition';
import { RiArrowDownLine } from 'react-icons/ri';
import TypeReveal from 'components/TypeReveal';
// import GrainOverlay from 'components/GrainOverlay';
// import AnimationWrapper from 'components/AnimationWrapper';
// import StyledLink from 'components/StyledLink';
import PropTypes from 'prop-types';

const Container = styled.section`
  position: relative;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.black};
  overflow: hidden;
`;

const Content = styled.div`
  width: 100%;
  height: 100svh;
  ${({ theme }) => theme.mixins.flexColCenter};
  gap: 2rem;
  margin: 0 auto;
  padding: 3rem;
  mix-blend-mode: difference;
  ${({ theme }) => theme.mediaQueries.sm} {
  }
`;

const Headline = styled.h1`
  visibility: ${({ scrolled }) => (scrolled ? 'hidden' : 'visible')};
  opacity: ${({ scrolled }) => (scrolled ? '0' : '1')};
  cursor: default;
  ${({ theme }) => theme.mixins.HeadlineXLMobile};
  color: ${({ theme }) => theme.colors.white};
  transition:
    transform 0.6s ease,
    visibility 0.3s ease,
    opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 11rem;

  span {
    text-align-last: justify;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    min-height: 22.4rem;
    gap: 3rem;
    ${({ theme }) => theme.mixins.HeadlineXL};

    span {
      width: max-content;
    }
    span + span {
      align-self: flex-end;
    }
  }
`;

// const Socials = styled.div`
//   visibility: ${({ scrolled }) => (scrolled ? 'hidden' : 'visible')};
//   opacity: ${({ scrolled }) => (scrolled ? '0' : '1')};
//   transition:
//     visibility 0.3s ease,
//     opacity 0.3s ease;

//   section {
//     color: ${({ theme }) => theme.colors.white};
//     display: flex;
//     justify-content: center;
//     gap: clamp(1rem, 2vw, 2rem);
//     flex-wrap: wrap;
//     padding: 0 1rem;
//   }

//   ${({ theme }) => theme.mediaQueries.lg} {
//     display: none;
//   }
// `;

const NavIcon = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  bottom: 2rem;
  transition: transform 0.3s ease;

  svg {
    font-size: 2rem;
    transition: color 0.3s ease;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      color: ${({ theme }) => theme.colors.accent};
      transform: translateY(0.4rem);
    }
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  z-index: -1;
  height: 100%;
  width: 100vw;
  object-fit: cover;
  pointer-events: none;
`;

const HomeHero = () => {
  const scrolled = useScrollPosition(250);

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Container>
      <Content>
        <Headline scrolled={scrolled}>
          <TypeReveal
            text={'Living for'}
            speed={80}
            startDelay={400} // slight delay before typing starts
            retriggerOnScroll={true} // retype every time it scrolls into view
          />
          <TypeReveal
            text={'the story.'}
            speed={80}
            startDelay={1400} // slight delay before typing starts
            retriggerOnScroll={true} // retype every time it scrolls into view
          />
        </Headline>
        {/* {socials && (
          <Socials scrolled={scrolled}>
            <AnimationWrapper stagger={0.1} threshold={1} as="section">
              {socials.map((social, index) => (
                <span key={index}>
                  <StyledLink label={social.label} url={social.url} />
                </span>
              ))}
            </AnimationWrapper>
          </Socials>
        )} */}
        <NavIcon onClick={() => handleScroll('intro')}>
          <RiArrowDownLine aria-hidden="true" />
        </NavIcon>
      </Content>
      {/* <GrainOverlay /> */}
      <BackgroundVideo
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-label="hero background video"
        onEnded={(e) => {
          e.currentTarget.currentTime = 0;
          e.currentTarget.play();
        }}
        poster="https://storage.googleapis.com/tyronshi/home-hero-media/hero-poster-2.webp"
      >
        <source
          src="https://storage.googleapis.com/tyronshi/home-hero-media/hero_1280x720_v1.mp4"
          type="video/mp4"
        />
      </BackgroundVideo>
    </Container>
  );
};

HomeHero.propTypes = {
  headline: PropTypes.string.isRequired,
  socials: PropTypes.array,
};

export default HomeHero;
